import { actions as csModalActions } from './csModalSlice'

export const promptCustomerServiceModal = () => (dispatch) =>
  new Promise((resolve) => {
    dispatch(csModalActions.openModal())
  })

export default 0
